var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagFigma = function SvgFlagFigma(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#777E91"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.167 6 2.113-2.466c.742-.865.127-2.2-1.012-2.2H3.167v9.332h9.1c1.14 0 1.755-1.336 1.013-2.2L11.167 6ZM4.5 9.333h7.768L9.41 6l2.857-3.333H4.5v6.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.167.667a.667.667 0 1 1 1.333 0v14.666a.667.667 0 1 1-1.333 0V.667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgFlagFigma;